const PrivacyPolicy = () => {
  return (
    <div className="page-container">
      <h1>Privacy Policy</h1>
      <p>
        Welcome to the VoinoxAI Privacy Policy. Your privacy is important to us, and this policy outlines how we collect, use, and safeguard your personal information.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        VoinoxAI collects the following types of information to provide and improve our services:
      </p>
      <ul>
        <li>
          <strong>Personal Information:</strong> When you sign up, we may collect your name, email address, and payment information.
        </li>
        <li>
          <strong>Audio Data:</strong> When you use our transcription feature, your audio recordings are processed and stored securely.
        </li>
        <li>
          <strong>Usage Data:</strong> We collect information about how you interact with our app to improve functionality and user experience.
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>
        The data we collect is used to:
      </p>
      <ul>
        <li>Provide transcription and summarization services.</li>
        <li>Improve app performance and functionality.</li>
        <li>Send updates and notifications related to your account or services.</li>
      </ul>

      <h2>3. Data Security</h2>
      <p>
        We take your privacy seriously. VoinoxAI uses advanced encryption techniques to ensure that your data, including audio recordings, is stored securely. Access to your data is restricted to authorized personnel only.
      </p>

      <h2>4. Sharing Your Information</h2>
      <p>
        We do not sell or share your personal information with third parties, except in the following cases:
      </p>
      <ul>
        <li>If required by law or legal process.</li>
        <li>To protect the rights, property, or safety of VoinoxAI or our users.</li>
      </ul>

      <h2>5. Your Rights</h2>
      <p>
        You have the following rights regarding your data:
      </p>
      <ul>
        <li>Access: You can request a copy of the personal data we have collected about you.</li>
        <li>Deletion: You can request that we delete your personal data, subject to applicable legal requirements.</li>
        <li>Updates: You can update your personal information at any time through your account settings.</li>
      </ul>

      <h2>6. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any significant changes through our app or via email.
      </p>

      <h2>7. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please contact us at <a href="mailto:support@voinoxai.com">support@voinoxai.com</a>.
      </p>

      <p>Last Updated: January 8, 2025</p>
    </div>
  );
};

export default PrivacyPolicy;
